import { Component, Input, OnInit } from '@angular/core';
import { SubdimensionAnualPMEModel } from 'src/app/model/NewFaseAnual.model';

@Component({
  selector: 'app-pme-estrategia1-fase-anual',
  templateUrl: './pme-estrategia1-fase-anual.component.html',
  styleUrls: ['./pme-estrategia1-fase-anual.component.css']
})
export class PmeEstrategia1FaseAnualComponent implements OnInit {

  @Input() indice : number;
  @Input() estadoData : number;
  @Input() areaNumber : number;
  @Input() subdimensionData : SubdimensionAnualPMEModel;
  @Input() simulacion: boolean;
  
  public isCollapsed = false;


  fechaClass1 : string = "input-fecha";
  fecha1Valida : boolean = false;
  startDate1: Date;
  fechaInicio1 : any;
  fechaFin1 : any;

  fechaClass2 : string = "input-fecha";
  fecha2Valida : boolean = false;
  startDate2: Date;
  fechaInicio2 : any;
  fechaFin2 : any;

  constructor(
    //@Inject(FaseEstrategicaComponent) private parentFE: FaseEstrategicaComponent,
  ) { }

  ngOnInit(): void {  

    var fechaInicio1Medicion =  this.subdimensionData.faseAnual.fechaDesde1e1 ? new Date(this.subdimensionData.faseAnual.fechaDesde1e1) : null;
    var fechaFin1Medicion =   this.subdimensionData.faseAnual.fechaHasta1e1 ? new Date(this.subdimensionData.faseAnual.fechaHasta1e1) : null;
    if (fechaFin1Medicion != null && fechaInicio1Medicion != null) {
      
      this.fechaInicio1  = {"day": fechaInicio1Medicion.getDate(), "month": fechaInicio1Medicion.getMonth() + 1, "year": fechaInicio1Medicion.getFullYear()};
      this.fechaFin1  = {"year": fechaFin1Medicion.getFullYear(),"month": fechaFin1Medicion.getMonth() + 1, "day": fechaFin1Medicion.getDate()};
      this.validarFechas1();
    }

    var fechaInicio2Medicion =  this.subdimensionData.faseAnual.fechaDesde2e1 ? new Date(this.subdimensionData.faseAnual.fechaDesde2e1) : null;
    var fechaFin2Medicion =   this.subdimensionData.faseAnual.fechaHasta2e1 ? new Date(this.subdimensionData.faseAnual.fechaHasta2e1) : null;
    if (fechaFin1Medicion != null && fechaInicio1Medicion != null) {
      
      this.fechaInicio2  = {"day": fechaInicio2Medicion.getDate(), "month": fechaInicio2Medicion.getMonth() + 1, "year": fechaInicio2Medicion.getFullYear()};
      this.fechaFin2  = {"year": fechaFin2Medicion.getFullYear(),"month": fechaFin2Medicion.getMonth() + 1, "day": fechaFin2Medicion.getDate()};
      this.validarFechas1();
    }
  }


  clearDateInicio1(){
    this.subdimensionData.faseAnual.fechaDesde1e1 = null;
    this.fechaInicio1 = "";
  }

  clearDateFin1(){
    this.subdimensionData.faseAnual.fechaHasta1e1 = null;
    this.fechaFin1 = "";
  }

  validarFechas1(){
    this.fechaClass1 = "input-fecha-error";
    this.fecha1Valida = false;
    if( this.fechaInicio1 != undefined && this.fechaFin1 != undefined  && this.fechaInicio1 != null && this.fechaFin1 != null){

      var fechaInicioMedicion = new Date(this.fechaInicio1.year, this.fechaInicio1.month -1, this.fechaInicio1.day);
      var fechaFinMedicion = new Date(this.fechaFin1.year, this.fechaFin1.month -1 , this.fechaFin1.day);

      this.subdimensionData.faseAnual.fechaDesde1e1 = fechaInicioMedicion;
      this.subdimensionData.faseAnual.fechaHasta1e1 = fechaFinMedicion;

      //if (fechaFinMedicion.getTime() - fechaInicioMedicion.getTime() >= 86400000) {
      if (fechaFinMedicion.getTime() - fechaInicioMedicion.getTime() >= 0) {
        this.fecha1Valida = true;
        this.fechaClass1 = "input-fecha";
      } else {
        this.fechaClass1 = "input-fecha-error";
        this.fecha1Valida = false;
      }

    } else {
      this.fechaClass1 =  "input-fecha-error";
      this.fecha1Valida = false;
    }
  }


  clearDateInicio2(){
    this.subdimensionData.faseAnual.fechaDesde2e1 = null;
    this.fechaInicio2 = "";
  }

  clearDateFin2(){
    this.subdimensionData.faseAnual.fechaHasta2e1 = null;
    this.fechaFin2 = "";
  }

  validarFechas2(){
    this.fechaClass2 = "input-fecha-error";
    this.fecha2Valida = false;
    if( this.fechaInicio2 != undefined && this.fechaFin2 != undefined  && this.fechaInicio2 != null && this.fechaFin2 != null){

      var fechaInicioMedicion = new Date(this.fechaInicio2.year, this.fechaInicio2.month -1, this.fechaInicio2.day);
      var fechaFinMedicion = new Date(this.fechaFin2.year, this.fechaFin2.month -1 , this.fechaFin2.day);

      this.subdimensionData.faseAnual.fechaDesde2e1 = fechaInicioMedicion;
      this.subdimensionData.faseAnual.fechaHasta2e1 = fechaFinMedicion;

      //if (fechaFinMedicion.getTime() - fechaInicioMedicion.getTime() >= 86400000) {
      if (fechaFinMedicion.getTime() - fechaInicioMedicion.getTime() >= 0) {
        this.fecha2Valida = true;
        this.fechaClass2 = "input-fecha";
      } else {
        this.fechaClass2 = "input-fecha-error";
        this.fecha2Valida = false;
      }

    } else {
      this.fechaClass2 =  "input-fecha-error";
      this.fecha2Valida = false;
    }
  }

  change1(){
    this.validarFechas1();
  }
  
  change2(){
    this.validarFechas2();
  }
  
  
  
}